import './FullScreenLoader.scss';

export const FullScreenLoader = ({ isShown }: { isShown: boolean }) => {
  return (
    <div className={`fullscreen-loader-overlay ${isShown ? 'shown' : 'hide'}`}>
      <div className="fullscreen-loader">
        <span className="loader-box fullscreen-loader-box"></span>
        <span className="loader-box fullscreen-loader-box"></span>
        <span className="loader-box fullscreen-loader-box"></span>
      </div>
    </div>
  );
};
